// TechStackPanel.jsx
import React, { useState } from 'react';
import './TechStackPanel.css';

function TechStackPanel() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="tech-stack-container">
      <button 
        className="tech-stack-toggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="tech-icon">⚙️</span> Tech Stack
      </button>
      
      {isOpen && (
        <div className="tech-stack-panel">
          <h2 className="implementation-title">Current Implementation</h2>
          
          <div className="tech-sections">
            <div className="tech-section">
              <h3>Core Technologies</h3>
              <div className="tech-items">
                <div className="tech-item">
                  <span className="tech-badge react">React</span> Frontend framework
                </div>
                <div className="tech-item">
                  <span className="tech-badge js">JavaScript</span> Primary language
                </div>
                <div className="tech-item">
                  <span className="tech-badge css">CSS3</span> Styling & animations
                </div>
                <div className="tech-item">
                  <span className="tech-badge openai">OpenAI</span> Natural language processing
                </div>
              </div>
            </div>
            
            <div className="tech-section">
              <h3>Search & Data</h3>
              <div className="tech-items">
                <div className="tech-item">
                  <span className="tech-badge quantum">Qiskit</span> Simulated quantum algorithms
                </div>
                <div className="tech-item">
                  <span className="tech-badge ml">Vector DB</span> Similarity search
                </div>
                <div className="tech-item">
                  <span className="tech-badge js">Node.js</span> Backend services
                </div>
                <div className="tech-item">
                  <span className="tech-badge cloud">AWS</span> Cloud hosting
                </div>
              </div>
            </div>
            
            <div className="tech-section">
              <h3>User Experience</h3>
              <div className="tech-items">
                <div className="tech-item">
                  <span className="tech-badge flex">Flexbox</span> Responsive layout
                </div>
                <div className="tech-item">
                  <span className="tech-badge axios">Axios</span> API requests
                </div>
                <div className="tech-item">
                  <span className="tech-badge redux">State</span> Component state management
                </div>
                <div className="tech-item">
                  <span className="tech-badge responsive">Mobile</span> Cross-device support
                </div>
              </div>
            </div>
          </div>
          
          <h2 className="evolution-title">Future Product Evolution</h2>
          
          <div className="tech-sections">
            <div className="tech-section">
              <h3>AI & Quantum</h3>
              <div className="tech-items">
                <div className="tech-item">
                  <span className="tech-badge quantum">Grover's</span> Real quantum search implementation
                </div>
                <div className="tech-item">
                  <span className="tech-badge pytorch">PyTorch</span> Fine-tuned movie expert model
                </div>
                <div className="tech-item">
                  <span className="tech-badge ml">Audio AI</span> Dialogue identification
                </div>
                <div className="tech-item">
                  <span className="tech-badge ml">Vision AI</span> Scene recognition
                </div>
              </div>
            </div>
            
            <div className="tech-section">
              <h3>Platform Expansion</h3>
              <div className="tech-items">
                <div className="tech-item">
                  <span className="tech-badge react">React Native</span> Mobile application
                </div>
                <div className="tech-item">
                  <span className="tech-badge api">Public API</span> Developer access
                </div>
                <div className="tech-item">
                  <span className="tech-badge cloud">Edge</span> Global content delivery
                </div>
                <div className="tech-item">
                  <span className="tech-badge vr">3D</span> Interactive visualizations
                </div>
              </div>
            </div>
            
            <div className="tech-section">
              <h3>Enhanced Features</h3>
              <div className="tech-items">
                <div className="tech-item">
                  <span className="tech-badge ml">RAG</span> Advanced film analysis
                </div>
                <div className="tech-item">
                  <span className="tech-badge social">Social</span> Sharing & recommendations
                </div>
                <div className="tech-item">
                  <span className="tech-badge analytics">Analytics</span> Viewing patterns & insights
                </div>
                <div className="tech-item">
                  <span className="tech-badge ml">Personalization</span> User preferences
                </div>
              </div>
            </div>
          </div>
          
          <div className="tech-footer">
            QReel combines quantum-inspired search algorithms with AI to deliver faster, more accurate movie information.
            <br />Currently using simulated quantum techniques with plans to implement true quantum computing advantages as the technology matures.
          </div>
        </div>
      )}
    </div>
  );
}

export default TechStackPanel;